// 业务切换弹框

import React, { useState, useEffect } from "react";
import { Modal, Checkbox, message, Button, Radio, Table, Space } from "antd";
import BoxServe from "../../../ajax/api/index";
const yw = {
  xdnup: "七牛业务",
  "airship-agent": "派享业务",
  "agent.x86": "点心业务",
  diting: "聚沙业务",
  ksc: "金山",
};

export default function BusinessSwitchingModel(props) {
  // 列表数据
  const [plainOptions, setPlainOptions] = useState([]);

  // 默认选中
  const [defaultChecked, setDefaultChecked] = useState([]);

  // 重置
  const [askBusiness, setAskBusiness] = useState(false);

  // 列表入参
  const [params] = useState({
    limit: 20, // 每页20条数据
    page: 1, // 当前页
  });

  const [resetParams, setResetParams] = useState({
    open: false,
  });

  // 分页
  const [tableParams, setTableParams] = useState({
    page: 1,
    limit: 5,
    current: 1
  });

  const businessColumns = [
    {
      title: "切换前上游",
      dataIndex: "beforeAskBusiness",
      key: "beforeAskBusiness",
      render: (_, record) => (
        <Space>
          <div style={{ display: "block" }}>
            {record.beforeAskBusiness} <br />
            <span style={{ color: "#faad14", isplay: "block" }}>{yw[record.beforeAskBusiness]}</span>
          </div>
        </Space>
      ),
    },
    {
      title: "切换后上游",
      dataIndex: "askBusiness",
      key: "askBusiness",
      render: (_, record) => (
        <Space>
          <div style={{ display: "block" }}>
            {record.askBusiness} <br />
            <span style={{ color: "#faad14", isplay: "block" }}>{yw[record.askBusiness]}</span>
          </div>
        </Space>
      ),
    },
    {
      title: "切换时间",
      dataIndex: "askBusinessTime",
      key: "askBusinessTime",
    },
    {
      title: "创建时间",
      dataIndex: "createTime",
      key: "createTime",
    },
  ];

  const [loading, setLoading] = useState(false);

  ;
  const [tableLoading, setTableLoading] = useState(false);

  // 切换记录

  const [businessList, setBusinessList] = useState([]);

  // 总条数
  const [total, setTotal] = useState(0);

  // 关闭弹框
  const onCancel = () => {
    props.handleBusinessSwitchinClose(false);
  };

  // 选择
  const onChange = ({ target: { value } }) => {
    setDefaultChecked(value);
  };

  // 获取上游列表
  const getList = async () => {
    try {
      setLoading(true);
      const { code, data = [] } = await BoxServe.upcompanyList(params).finally(() => {
        setLoading(false);
      });
      if (String(code) === "0") {
        const optionsList = data?.map((item) => {
          return {
            ...item,
            label: item.upName,
            value: item.agentName,
          };
        }); // 默认全部选中
        setPlainOptions(optionsList);

        // const checkedItem = plainOptions.filter((item) => optionsList.some((ele) => ele.agentName === item.askBusiness));
        if (props.list?.length === 1) {
          const checkedList = data?.filter((item) => item.agentName === props.item.askBusiness)?.[0]?.agentName; // 默认全部选中
          setDefaultChecked(checkedList);
        } else {
          setDefaultChecked("");
        }
      } else {
        message.error("错误！");
      }
    } catch (error) {
      setLoading(false);
      message.error(error.message || error.msg);
    }
  };

  // 重置选择
  const onChangeReset = (e) => {
    console.log(e.target.checked);
    setAskBusiness(e.target.checked);
  };

  useEffect(() => {
    if (props.open) {
      getList();
      
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open]);

  useEffect(() => {
    if (props.open) {
      getBusinessList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open, tableParams]);

  // 提交
  const handleSubmit = async () => {
    const deviceNoList = props.list?.join(",") || "";
    const upCompanyList = defaultChecked;
    const params = {
      deviceNoList,
      upCompanyList,
    };
    if (askBusiness) {
      params.askBusiness = "";
      params.upCompanyList = "";
      setResetParams({
        ...params,
        ...resetParams,
        open: true,
      });
    } else {
      handleSubmitConfirm(params);
    }
  };

  const handleSubmitConfirm = async (params) => {
    try {
      setLoading(true);
      const { code, msg } = await BoxServe.updateDevice(params).finally(() => {
        setLoading(false);
        setAskBusiness(false);
      });
      if (String(code) === "0") {
        message.success(msg);
        setTimeout(() => {
          onCancel();
          props.getBusinessList("business"); // 列表需要重置选中
        }, 200);
      } else {
        message.error("错误！");
      }
    } catch (error) {
      setLoading(false);
      message.error(error.message || error.msg);
      console.log(error);
    }
  };

  // 切换上游记录列表
  const getBusinessList = async () => {
    try {
      setTableLoading(true)
      const {
        code,
        data = [],
        count,
      } = await BoxServe.businessList({
        deviceNo: props?.item?.deviceNo,
        page: tableParams?.page,
        limit: tableParams?.limit,
      }).finally(() => {
       setTableLoading(false);
      });
      if (String(code) === "0") {
        setTotal(count ? Number(count) : 0);
       const newList =  data?.map(item => { 
          return {
            ...item,
            key: item.id
          }
       })
        setBusinessList([...newList]);
      } else {
        message.error("错误！");
      }
    } catch (error) {
      setLoading(false);
      message.error(error.message || error.msg);
    }
  };

  // 重置确认
  const handleResetConfirm = () => {
    const { askBusiness, upCompanyList, deviceNoList } = resetParams;
    const params = {
      deviceNoList,
      upCompanyList,
      askBusiness,
    };
    setAskBusiness(false);
    setResetParams({
      ...resetParams,
      open: false,
    });
    handleSubmitConfirm(params);
  };

  // 重置取消
  const handleResetCancel = () => {
    setResetParams({
      ...resetParams,
      open: false,
    });
    setAskBusiness(false);
  };

  // 分页等
  const onChangePage = (pagination) => {
    const { current, pageSize } = pagination;
    setBusinessList([]);
    setTableParams({
      page: current,
      limit: pageSize,
    });
  };

  return (
    <>
      <div className="business-switching">
        <Modal title="业务切换" width="1000px" className="business-model" footer={null} open={props.open} onCancel={onCancel}>
          <div className="box">
            <span className="title">盒子编号</span>
            <div className="list list-boder">
              {props.list?.map((item, index) => (
                <span key={item} className="list-item">
                  {item}
                </span>
              ))}
              <span className="list-item">等{props?.list?.length}个盒子</span>
            </div>
          </div>
          <div className="box">
            <span className="title">上游</span>
            <div className="list">
              <Radio.Group key={defaultChecked} options={plainOptions} value={defaultChecked} onChange={onChange} />
              {/* <Checkbox style={{ marginLeft: "20px" }} checked={askBusiness} onChange={onChangeReset}>
                重置
              </Checkbox> */}
            </div>
          </div>
          <Button type="primary" className="box-btn" loading={loading} shape="round" size={"large"} onClick={handleSubmit}>
            切换
          </Button>

          <Table
            id="table"
            columns={businessColumns}
            dataSource={businessList}
            loading={tableLoading}
            pagination={{
              showSizeChanger: false,
              pageSizeOptions: [5, 10],
              defaultPageSize: tableParams.limit,
              total,
              ...tableParams,
              showTotal: (total) => {
                return `共 ${total} 条`;
              },
            }}
            onChange={onChangePage}
            className="device-home"
          />
        </Modal>

        {/* 重置确认 */}
        <Modal title="温馨提示" open={resetParams.open} centered onOk={handleResetConfirm} onCancel={handleResetCancel}>
          <p>确认要重置？</p>
        </Modal>
      </div>
    </>
  );
}
